<template lang="pug">
div
  UiCardSection
    UiStack
      UiStackItem(fill)
        .ui-card-section-title {{ $t("admin_tools.tabs.failed_vendors") }}
      UiStackItem
        UiButton(
          @click="exportToExcel"
          icon="FileDownload"
        ) {{ $t("resellers.export_to_excel") }}
  UiCardSection
    RestTable(
      namespace="logs"
      :headers="headers"
      ref="failedVendorsTable"
      :fetch-handler="getData"
      :initial-filters="initialFilters"
      embed
    )
      template(#filters="{ filters, updateFilters }")
        UiStack
          UiStackItem(fill)
            UiFormGroup(:label="$t('admin_tools.failed_vendors.name')")
              UiInput(
                :modelValue="filters.name"
                type="search"
                @update:modelValue="updateFilters({ name: $event })"
              )
          UiStackItem(fill)
            UiFormGroup(:label="$t('admin_tools.failed_vendors.company_name')")
              UiInput(
                :modelValue="filters.company_name"
                type="search"
                @update:modelValue="updateFilters({ company_name: $event })"
              )
      template(#cell:actions="{ item }")
        UiButton(
          size="sm"
          variant="smooth-danger"
          @click="deleteVendor(item)"
          icon="Trash"
        ) {{ $t("actions.delete") }}
</template>

<script>
import ApiFailedVendors from "@/api/failed_vendors.js";
export default {
  data() {
    return {
      initialFilters: {
        company_name: "",
        name: "",
      },
      headers: [
        {
          key: "id",
          label: "#",
          sortable: true,
          squeeze: true,
        },
        {
          key: "company_name",
          label: "Company",
          sortable: true,
          squeeze: true,
        },
        {
          key: "name",
          label: "Vendor",
          sortable: true,
          squeeze: true,
        },
        {
          key: "actions",
          label: "#",
          sortable: false,
          squeeze: true,
        },
      ],
    };
  },

  methods: {
    reload() {
      this.$refs.failedVendorsTable.fetchData();
    },

    getData(params, config) {
      return ApiFailedVendors.fetchVendors(params, config).then((resp) => {
        return {
          items: resp.data.vendors,
          meta: resp.data.meta,
        };
      });
    },

    deleteVendor(item) {
      return new Promise((res) => {
        ApiFailedVendors.deleteVendor(item.id).then((resp) => {
          this.reload();
        });
      });
    },

    exportToExcel() {
      ApiFailedVendors.exportToExcel()
        .then((resp) => {
          let fileURL = window.URL.createObjectURL(new Blob([resp.data]));
          let fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", `failed_vendors.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((e) => {});
    },
  },
};
</script>

<style scoped></style>
